import { render } from "./SliderPopup.vue?vue&type=template&id=044a81f0&scoped=true"
import script from "./SliderPopup.vue?vue&type=script&lang=js"
export * from "./SliderPopup.vue?vue&type=script&lang=js"

import "./SliderPopup.vue?vue&type=style&index=0&id=044a81f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044a81f0"]])

export default __exports__